function stringToObject(str, delimiter) {
    var result = {};
    if (str && str.length > 0) {
        str = str.split(delimiter || ',');
        for (var i = 0; i < str.length; i++) {
            var cur = str[i].split('=');
            result[cur[0]] = cur[1];
        }
    }
    return result;
}

function getParamsUrl(url) {
    var regex = /[?&]([^=#]+)=([^&#]*)/g,
        params = {},
        match;
    while (match = regex.exec(url)) {
        params[match[1]] = match[2];
    }
    return params;
}

function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
}

function setCookie(name, value) {
    var today = new Date();
    var expiry = new Date(today.getTime() + 30 * 24 * 3600 * 1000);
    document.cookie = name + "=" + escape(value) + "; path=/; expires=" + expiry.toGMTString();
}
var currentUrl = getParamsUrl(window.location.href);

if (Object.keys(currentUrl).length > 0) {
	var gclid = currentUrl.gclid;
	var gacreative = currentUrl.ga_creative;
	var utmsrc = currentUrl.utm_source;
	var utmmed = currentUrl.utm_medium;
	var utmcampaign = currentUrl.utm_campaign;
	var utmcontent = currentUrl.utm_content;
	var utmterm = currentUrl.utm_term;
	var adgroupid = currentUrl.adgroupid;


	if (gclid != "undefined") {
		setCookie('gclid', gclid);
	}

	if (gclid != "undefined") {
		setCookie('gacreative', gacreative);
	}

	if (utmsrc != "undefined") {
		setCookie('utmsrc', utmsrc);
	}

	if (utmmed != "undefined") {
		setCookie('utmmed', utmmed);
	}

	if (utmcampaign != "undefined") {
		setCookie('utmcampaign', utmcampaign);
	}

	if (utmcontent != "undefined") {
		setCookie('utmcontent', utmcontent);
	}

	if (utmterm != "undefined") {
		setCookie('utmterm', utmterm);
	}

	if (adgroupid != "undefined") {
		setCookie('adgroupid', adgroupid);
	}
	
}

